import { runtimeConfig } from "@src/runtime-config";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/**
 * @returns The URL to the login page of the ULM
 *
 * Appends the following query params to the ULM URL:
 * - "client=sphereDashboard" to indicate the consumer of the ULM is the XG Dashboard
 * - "parent_url" where we passed the current location to redirect after a successful login
 * - If the current location is a deep link where the workspace is defined then the ULM should
 * only allow login in the current server instance. To achieve this we also append the "server"
 * query param with the current server identifier.
 */
export function getUlmUrl(): string {
  const url = new URL(`${runtimeConfig.urls.sphereEntryPageUrl}/login`);

  url.searchParams.append("client", "sphereDashboard");

  const parentUrl = globalThis.location.href;
  url.searchParams.append("parent_url", parentUrl);

  const pathname = globalThis.location.pathname;
  if (pathname !== "" && pathname !== "/") {
    const serverIdentifier: FaroCoreApiTypes.ServerIdentifier =
      runtimeConfig.appEnv.includes("com") ? "sphere_2_com" : "sphere_2_eu";

    url.searchParams.append("server", serverIdentifier);
  }

  return url.href;
}

/**
 * Returns true iff the login method of the passed user is FARO-SPHERE
 *
 * @param loggedInUser Logged in user object
 */
export function isLoginProviderFaro(
  loggedInUser: FaroCoreApiTypes.LoggedInUser | null
): boolean {
  if (!loggedInUser) {
    return false;
  }

  return loggedInUser.authenticationInfo.providerId === "FARO-SPHERE";
}
